import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
  cached: {},
  projects: {
    results: [],
  },
  loadingProjects: false,
  projectMethodologists: {
    results: [],
  },
}

export const getters = {
  projects: (state) => state.projects,
  loadingProjects: (state) => state.loadingProjects,
  projectMethodologists: (state) => state.projectMethodologists,
}

export const mutations = {
  CACHE_PROJECT(state, project) {
    state.cached = project
  },
  SET_PROJECTS(state, data) {
    state.projects = data
  },
  SET_LOADING(state, loading) {
    state.loadingProjects = loading
  },
  SET_PROJECT_METHODOLOGISTS(state, data) {
    state.projectMethodologists = data
  },
}

export const actions = {
  createProject({ dispatch }, payload) {
    axios
      .post(appConfig.server_url + '/projects_management/project/', payload)
      .then((resp) => {
        dispatch('fetchProjects')
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Proyecto creado correctamente.',
        })
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Proyecto no fue creado correctamente.',
        })
      })
  },
  updateProject({ dispatch }, payload) {
    console.log(payload)
    axios
      .put(
        appConfig.server_url + `/projects_management/project/${payload.id}/`,
        payload
      )
      .then((resp) => {
        dispatch('fetchProjects')
        store.dispatch('methodologist/fetchProjects')
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Proyecto actualizado correctamente.',
        })
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Proyecto no fue actualizado correctamente.',
        })
      })
  },
  deleteProject({ dispatch }, projectId) {
    axios
      .delete(
        appConfig.server_url + `/projects_management/project/${projectId}`
      )
      .then((resp) => {
        dispatch('fetchProjects')
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Proyecto eliminado correctamente.',
        })
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Proyecto no fue eliminado correctamente.',
        })
      })
  },
  fetchProjects({ commit }, query) {
    commit('SET_LOADING', true)
    axios
      .get(
        appConfig.server_url + `/projects_management/project/?project_type=0`
      )
      .then((resp) => {
        if (resp.status === 200) {
          commit('SET_PROJECTS', resp.data)
          commit('SET_LOADING', false)
        }
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando proyectos.',
        })
      })
  },
  fetchProjectMethodologists({ commit }, projectId) {
    commit('SET_LOADING', true)
    axios
      .get(
        appConfig.server_url +
          `/profile_management/profile?project=${projectId}&role=0`
      )
      .then((resp) => {
        if (resp.status === 200) {
          commit('SET_PROJECT_METHODOLOGISTS', resp.data)
          commit('SET_LOADING', false)
        }
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando Metódologos.',
        })
      })
  },
  createMethodologist({ commit, dispatch }, payload) {
    if (payload.user.password === null) {
      delete payload.user.password
    }
    commit('SET_LOADING', true)
    axios
      .post(appConfig.server_url + '/profile_management/profile/', payload)
      .then((resp) => {
        dispatch('fetchProjectMethodologists', payload.project_id)
        commit('SET_LOADING', false)
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Metódologo creado correctamente.',
        })
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Metódologo no fue creado correctamente.',
        })
      })
  },
  updateMethodologist({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    axios
      .put(payload.url, payload)
      .then((resp) => {
        commit('SET_LOADING', false)
        dispatch('fetchProjectMethodologists', payload.project_id)
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Metódologo actualizado correctamente.',
        })
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Metódologo no fue actualizado correctamente.',
        })
      })
  },
  deleteMethodologist({ commit, dispatch }, payload) {
    axios
      .delete(payload.url)
      .then((resp) => {
        dispatch('fetchProjectMethodologists', payload.projectId)
        store.dispatch('utils/message', {
          type: 'success',
          title: 'Correcto',
          text: 'Metódologo eliminado correctamente.',
        })
      })
      .catch(() => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Metódologo no fue eliminado correctamente.',
        })
      })
  },

  async findPublicProject(_, query) {
    try {
      const res = await axios.get(
        `${appConfig.server_url}/projects_management/project/find_public_project/${query}`
      )
      return res
    } catch (err) {
      return err.response
    }
  },

  async findExpertPerProject(_, query){
    try {
      const res = await axios.get(
        `${appConfig.server_url}/profile_management/profile/find_project/${query}`
      )
      return res
    } catch (err) {
      return err.response
    }
  }
}
